import React from 'react';

export default (props) => {
  const { children, ...otherProps } = props;

  return (
    <span className="label" {...otherProps}>
      {children}
    </span>
  );
};
